/* eslint-disable indent */
export const removeNullProperties = (object: object): object =>
  Object.entries(object).reduce((a, [k, v]) => (v ? { ...a, [k]: v } : a), {});

export const serializeObject = (obj?: any) =>
  obj
    ? Object.keys(obj)
        .filter((k: any) => obj[k] != null)
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        .map((k) => (k !== 'statuses' ? `${k}=${encodeURIComponent(obj[k])}` : `${k}=${obj[k]}`))
        .join('&')
    : '';

export const isObjectEmpty = (items: any) => {
  if (!items || items === undefined) return true;
  const { length } = Object.keys(items);

  return length === 0;
};
